export default __webpack_public_path__ + "static/favicon-20eb4f55200cfcd685cab546812eaa52.ico";